import React from "react";
import { Control, Controller } from "react-hook-form";
import { ClientInfoForm } from "features/ClientInfo/ClientInfo";

import { NamedInput } from "components/NamedInput/NamedInput";

import styles from "../../styles.module.css";

type Props = {
  title: string;
  control: Control<ClientInfoForm>;
};

export const OOOIp = ({ title, control }: Props): JSX.Element => {
  return (
    <div className="h-50">
      <h3 className={styles.user_type_title}>{title}</h3>
      <Controller
        name="firstname"
        control={control}
        render={({ field }) => (
          <NamedInput
            {...field}
            label="Наименование"
            style={{ width: "100%" }}
          />
        )}
      />
      <div className="flex items-center mt-5 gap-10">
        <Controller
          name="inn"
          control={control}
          render={({ field }) => (
            <NamedInput {...field} className="w-24" label="ИНН" />
          )}
        />
        <Controller
          name="kpp"
          control={control}
          render={({ field }) => (
            <NamedInput {...field} className="w-24" label="КПП" />
          )}
        />
        <Controller
          name="bank"
          control={control}
          render={({ field }) => (
            <NamedInput {...field} style={{ width: 160 }} label="Р/С" />
          )}
        />
        {/* <Controller
          name="kpp"
          control={control}
          render={({ field }) => (
            <NamedInput {...field} className="w-24" label="ОКПО" />
          )}
        /> */}
      </div>
      <div className="mt-5">
        <Controller
          name="address"
          control={control}
          render={({ field }) => (
            <NamedInput {...field} label="Адрес" style={{ width: "100%" }} />
          )}
        />
      </div>
    </div>
  );
};
